import swal from "sweetalert";
import { useState } from "react";
import dataReglas from "../../data.json";
import useUser from "../../../../core/hooks/use-user";
import useModal from "../../../../core/hooks/use-modal";
import FormReglasTurnos from "../components/form-nomina-reglas";
import { sweetAl, toast } from "../../../../core/helpers/message-helper";
import Datatable from "../../../../core/ui/components/Datatable";
import { API_URL } from "../../../../core/config/env";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";

import {
    activarRegla,
    inactivarRegla,
    obtenerReglaPorId,
} from "../../services/nomina-reglas-service";
import FormAsignarReglas from "../components/form-asignar-nomina-reglas";

const NominaReglas = () => {
    const { getAccessToken, userCan } = useUser();
    const token = getAccessToken();

    const [dtInstance, onDtInstance] = useState({});

    const modalAsignar = useModal();
    const modalReglas = useModal({
        title: "Agregar Regla",
        data: { regla: {}, turnosSemanales: true },
    });

    const onSaved = (response) => {
        toast.success(response.message);
        modalReglas.set({
            show: false,
            data: {
                regla: {},
                turnosSemanales: true,
            },
        });

        dtInstance.ajax.reload();
    };

    const getDtInstance = (dt) => onDtInstance(dt);

    let tableButtons = [];

    if (userCan("nominaCrearReglas")) {
        tableButtons.push({
            titleAttr: "Agregar Regla",
            text: '<i class="fas fa-plus"></i>',
            action: function () {
                modalReglas.set({
                    show: true,
                    title: "Agregar Regla",
                    data: {
                        regla: {},
                        turnosSemanales: true,
                    },
                });
            },
            className: "btn btn-sm btn-secondary",
        });
    }

    if (userCan("nominaEditarReglas")) {
        tableButtons.push({
            titleAttr: "Editar Regla",
            text: '<i class="fas fa-pen"></i>',
            action: async (_, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const resp = await obtenerReglaPorId(data.id);
                if (!resp.status) return toast.error(resp.message);
                mostrarModalEdicion(resp);
            },
            className: "btn btn-sm btn-grey",
        });
    }

    if (userCan("nominaInactivarReglas")) {
        tableButtons.push({
            titleAttr: "Inactivar Regla",
            text: '<i class="fas fa-trash"></i>',
            className: "btn btn-sm btn-danger",
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea inactivar esta regla?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        inactivar: {
                            text: "Inactivar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning("No se a inactivado la regla");
                        break;
                    case "inactivar": {
                        const resp = await inactivarRegla(data.id);

                        if (!resp.status) {
                            return sweetAl.error(
                                "Ha ocurrido un error al inactivar la regla"
                            );
                        }

                        sweetAl.success(
                            "La regla fue inactivada correctamente"
                        );
                        dt.ajax.reload();
                        break;
                    }
                }
            },
        });
    }

    if (userCan("nominaActivarReglas")) {
        tableButtons.push({
            titleAttr: "Activar Regla",
            text: '<i class="fas fa-check"></i>',
            className: "btn btn-sm btn-primary",
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea activar esta regla?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        activar: {
                            text: "Activar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning("No se ha activado la regla");
                        break;
                    case "activar": {
                        const resp = await activarRegla(data.id);
                        if (!resp.status) {
                            return sweetAl.error(
                                "Ha ocurrido un error al activar la regla"
                            );
                        }

                        sweetAl.success("La regla fue activada");
                        dt.ajax.reload();
                        break;
                    }
                }
            },
        });
    }

    if (userCan("nominaAsignarReglas")) {
        tableButtons.push({
            titleAttr: "Asignar a empleados",
            text: '<i class="fas fa-check-double"></i>',
            action: function (_, dt) {
                const data = dt.row({ selected: true }).data();

                if (data && data.status == 1) {
                    modalAsignar.set({
                        show: true,
                        data: { idRegla: data.id },
                    });
                }
            },
            className: "btn btn-sm btn-salmon",
        });
    }

    tableButtons = [
        ...tableButtons,
        {
            titleAttr: "Exportar a Excel",
            text: '<i class="fas fa-file-excel"></i>',
            extend: "excelHtml5",
            className: "btn btn-sm btn-success",
            exportOptions: {
                modifier: {
                    order: "current",
                    page: "all",
                },
            },
            filename: "turnos",
        },
        {
            titleAttr: "Imprimir",
            text: '<i class="fa fa-lg fa-print"></i>',
            extend: "print",
            className: "btn btn-sm btn-warning",
        },
    ];

    const mostrarModalEdicion = (res) => {
        const diasSemana = dataReglas.DIAS_SEMANA_EDICION.reduce(
            (prev, dia) => {
                prev[dia.id] = res.data[dia.id]
                    ? {
                          label: res.data[`turnoSede${dia.diaAlias}`],
                          value: res.data[dia.id],
                      }
                    : null;

                return prev;
            },
            {}
        );

        modalReglas.set({
            show: true,
            title: "Editar Regla",
            data: {
                regla: { ...res.data, ...diasSemana },
                turnosSemanales: !(
                    res.data["turno_sede_lunes_id"] ||
                    res.data["turno_sede_martes_id"] ||
                    res.data["turno_sede_miercoles_id"] ||
                    res.data["turno_sede_jueves_id"] ||
                    res.data["turno_sede_viernes_id"]
                ),
            },
        });
    };

    const dtOptions = {
        searchable: true,
        serverSide: false,
        dom: "Bfrtip",
        id: "tablaReglas",
        select: {
            style: "single",
        },
        buttons: tableButtons,
        ajax: {
            url: `${API_URL}/reglas`,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", `Bearer ${token}`);
            },
            type: "get",
            dataType: "json",
            error: function () {
                toast.error(
                    "Ha ocurrido un error al obtener el listado de reglas"
                );
            },
        },
        columns: [
            { data: "id" },
            { data: "nombre" },
            { data: "horas_dia" },
            { data: "dias_descanso_semana" },
            { data: "dias_descanso_mes" },
            { data: "max_horas_turnos_seguidos" },
            { data: "max_horas_extra_semana" },
            { data: "status" },
        ],
        columnDefs: [
            {
                targets: 7,
                createdCell: function (td, cellData) {
                    td.textContent = cellData == 1 ? "Activo" : "Inactivo";
                    td.classList.add(
                        cellData == 1 ? "text-success" : "text-warning"
                    );
                    td.classList.add("text-bold");
                },
            },
        ],
    };

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>
                    NÓMINA / Reglas
                </div>
            </div>
            <Datatable options={dtOptions} dtInstance={getDtInstance}>
                <table className="w-100 table table-hover" id="tablaReglas">
                    <thead className="bg-dark">
                        <tr>
                            <th className="text-center text-white">Id</th>
                            <th className="text-center text-white">Nombre</th>
                            <th className="text-center text-white">
                                Horas Día
                            </th>
                            <th className="text-center text-white">
                                Días Descanso Semana
                            </th>
                            <th className="text-center text-white">
                                Días Descanso Mes
                            </th>
                            <th className="text-center text-white">
                                Max Horas Turnos Seguidos
                            </th>
                            <th className="text-center text-white">
                                Max Horas Extra Semana
                            </th>
                            <th className="text-center text-white">Estado</th>
                        </tr>
                    </thead>
                </table>
            </Datatable>
            <FormReglasTurnos modalState={modalReglas} onCreated={onSaved} />
            <FormAsignarReglas modalState={modalAsignar} />
        </ContentWrapper>
    );
};

export default NominaReglas;
